import { useDroppable } from '@dnd-kit/react';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

export type DropStatus = 'Target' | 'Source' | 'Unconcerned';

interface DroppableZoneProps {
  children: ReactNode;
  id: string;

  isDropDisabled?: boolean;
  type: string;
  className?: string;
}

export const DroppableZone: FC<DroppableZoneProps> = ({ id, children, className, ...others }) => {
  const { ref } = useDroppable({
    id,
    accept: 'tab',
  });

  return (
    <div ref={ref} className={classNames(className)}>
      <div id={id} className="w-100" {...others}>
        {children}
      </div>
    </div>
  );
};

DroppableZone.displayName = 'DroppableZone';
